import React, { useState, DragEvent } from 'react';
import ApiDocument from '../code/api/ApiDocument';
import CclDataTable, { CclDataTableButtonType, CclDataTableColumnDef, CclDataTableColumnType } from './CclDataTable';
import { el } from "date-fns/locale";
import { Badge, Spinner } from "reactstrap";

interface IFileUploaderMulti {
  buttonTextChoose: string | undefined;
  buttonTextUpload: string | undefined;
  fileGroupId: number | undefined | null;
  fileGroup: string;
  newGroupOnUpload: boolean;
  onUploadStart: Function;
  onUploadSuccess(groupId: number);
  onUploadFail(groupId: number);
}

export default function FileUploaderMulti({ buttonTextChoose, buttonTextUpload, fileGroupId, fileGroup, newGroupOnUpload,
  onUploadStart, onUploadSuccess, onUploadFail }: IFileUploaderMulti) {
  const [files, setFiles] = useState<File[]>([]);
  const [dragStyle, setDragStyle] = useState<string>("");
  const [uploading, setUploading] = useState<boolean>(false);
  const [status, setStatus] =  React.useState<string>("Uploading...");

  const uploadFilesColumnDefs: CclDataTableColumnDef[] = [
    {
      fieldName: "name",
      title: "File Name",
      visible: true,
      type: CclDataTableColumnType.Data
    },
    {
      fieldName: "type",
      title: "Type",
      visible: true,
      type: CclDataTableColumnType.Data
    },
    {
      fieldName: "lastModified",
      title: "File Date",
      visible: true,
      formatData: (f: any) => { f.toLocaleString() },
      type: CclDataTableColumnType.Data
    },
    {
      fieldName: "",
      title: "",
      type: CclDataTableColumnType.Button,
      buttonName: "delete",
      buttonText: "X",
      buttonType: CclDataTableButtonType.Delete,
      visible: true
    }
  ];

  function handleRowDeleteButtonClick(rowData: File, buttonName: string) {
    var newFiles = files.filter((f) => f !== rowData);
    setFiles(newFiles);
  }

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files) {
      setFiles(Array.from(e.target.files));
    }
  };

  async function handleUploadClick() {
    onUploadStart();
    setUploading(true);
    if (!fileGroupId || newGroupOnUpload) {
      ApiDocument.createFileGroup(fileGroup).then((res) => {
        if (!!res) {
          fileGroupId = res.bidPeriodFileGroupId;
          doDocumentUpload(fileGroupId);
        }
      });
    } else {
      doDocumentUpload(fileGroupId);
    }
  };

  function doDocumentUpload(groupId: number): void {
    if (files.length === 0) {
      setUploading(false);
      return;
    }

    const BATCH_SIZE = 10;
    const batches: File[][] = [];

    for (let i = 0; i < files.length; i += BATCH_SIZE) {
      batches.push(files.slice(i, i + BATCH_SIZE));
    }

    const uploadBatch = (index: number): void => {
      setStatus(`Uploading Batch ${index + 1}`);
      if (index >= batches.length) {
        setFiles([]);
        if (onUploadSuccess) onUploadSuccess(groupId);
        setUploading(false);
        return;
      }

      const formData = new FormData();
      batches[index].forEach((file: File) => formData.append('file', file));

      ApiDocument.uploadDocuments(groupId, formData).then((res: boolean) => {
        if (res) {
          uploadBatch(index + 1);
        } else {
          if (onUploadFail) onUploadFail(groupId);
          setUploading(false);
        }
      });
    };

    uploadBatch(0);
  }

  function handleFilesDrop(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      var newFiles: File[] = [...files];

      for (var i = 0; i < droppedFiles.length; i++) {
        var f = droppedFiles.item(i);
        if (!!f) {
          newFiles.push(f);
        }
      }

      setFiles(newFiles);
    }
    setDragStyle("");
  }

  function handleDragging(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragStyle("drag-over");
  }

  function leaveDragging(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragStyle("");
  }

  return (
    <React.Fragment>
      <div className={"choose-group " + dragStyle} onDragOver={handleDragging} onDragEnter={handleDragging} onDragLeave={leaveDragging}
        onDrop={handleFilesDrop}>
        {!uploading &&
          <React.Fragment>
            <label htmlFor="fileUploadInput" className="btn btn-outline-primary btn-md">{buttonTextChoose || "Choose File"}</label>
            <input id="fileUploadInput" type="file" accept='application/pdf' hidden={true} onChange={handleFileChange} multiple={true}
              disabled={uploading} /><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </React.Fragment>}
        {!uploading && files.length > 0 && <React.Fragment>
          <button onClick={handleUploadClick} className="btn btn-outline-primary">{buttonTextUpload || "Upload Files"}</button>
        </React.Fragment>}
        {uploading && <Badge color="info" className="fs-2"><Spinner>Uploading</Spinner><span>{' '}{status}</span></Badge>}
        {!uploading && <div className="upload-group">=======&gt; Drop Here! &lt;======</div>}
      </div>
      {files.length > 0 &&
        <React.Fragment>
          <div className='waives-table-wrapper'>
            <CclDataTable
              name={"uploadFilesTable"}
              tableData={files || []}
              columnDefinitions={uploadFilesColumnDefs}
              rowSelect={true}
              onRowSelect={null}
              onButtonClick={handleRowDeleteButtonClick} />
          </div>
        </React.Fragment>}
    </React.Fragment>
  );
};

